import { IAnnotation } from 'react-ace';
import jsonMap from 'json-source-map';
import { ValidationError } from '../hooks';

type JSONMap = {
  pointers: {
    [key: string]: {
      key?: { line: number; column: number };
      value?: { line: number; column: number };
    };
  };
};

const errorPathToJsonPointer = (errorPath: string): string => {
  // Error paths look like: "content[0].category" or "content[0].children[2].id"
  // JSON pointers look like: "/0/category" or "/0/children/2/id"
  // The "content" prefix comes from the validation API wrapper, not the actual JSON
  return (
    errorPath
      .replace(/^content/, '') // remove "content" prefix
      .replace(/\[(\d+)\]/g, '/$1') // [0] -> /0
      .replace(/\./g, '/') // . -> /
      .replace(/^([^/])/, '/$1') // ensure leading slash
      .replace(/\/+/g, '/') || '/' // clean up double slashes, default to root
  );
};

export const getErrorAnnotations = (
  jsonText: string,
  errors: ValidationError[]
): IAnnotation[] => {
  if (!errors.length) return [];

  try {
    const jsmap: JSONMap = jsonMap.parse(jsonText);

    return errors
      .map((error): IAnnotation | null => {
        const pointer = errorPathToJsonPointer(error.key);
        const location = jsmap.pointers[pointer];

        if (!location) return null;

        const line = location.key?.line ?? location.value?.line ?? 0;
        return {
          row: line,
          column: 0,
          text: `${error.key}: ${error.message}`,
          type: 'error',
        };
      })
      .filter((a): a is IAnnotation => a !== null);
  } catch {
    return [];
  }
};
